import React, { useState, useRef, useEffect, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from '../elements/Button';
import If from '../components/If';
import { PRODUCTS } from '../config/constants';
import MapaContext from '../context/Mapa';
import TextFieldGoogleAutocomplete from '../components/TextFieldGoogleAutocomplete';
import SelectProducts from '../components/SelectProducts';
import getIconByProduto from '../helpers/getIconByProduto';
import Switch from '../components/Switch';

const ContainerForm = styled.div`
  padding: 17px;
`;
ContainerForm.displayName = 'ContainerForm';

const ContainerInput = styled.div`
  margin-bottom: 20px;
  .google-places-autocomplete > div {
    margin-bottom: 0;
  }
`;

const FormBusca = styled.form``;
const SwitchContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 23px 0;
`;

function Search({
  products,
  renderOption,
  onSelectPlace,
  children,
  validate,
  defaultValues,
  height,
}) {
  const formSearchRef = useRef();
  const searchInputRef = useRef();
  const [messageAddressError, setMessageAddressError] = useState(null);
  const [messageProductError, setMessageProductError] = useState(null);
  const [produtoSelecionado, setprodutoSelecionado] = useState('');
  const [coordenadas, setCoordenadas] = useState({ lng: '', lat: '' });
  const [endereco, setEndereco] = useState('');
  const [showForm, setShowForm] = useState(true);
  const {
    setSearch,
    showResumoResultados,
    setShowResultados,
    openBox,
    findEstablishment,
    raio,
    setFullBox,
    companyName,
  } = useContext(MapaContext);

  useEffect(() => {
    if (onSelectPlace) {
      onSelectPlace(coordenadas);
    }
  }, [coordenadas, onSelectPlace]);

  useEffect(() => {
    if (products.length === 1 && produtoSelecionado === '') {
      setprodutoSelecionado(products[0]);
    }
  }, [products, produtoSelecionado]);

  function setDefaultValues() {
    const { lon, lat, referencePoint, produto } = defaultValues;

    if (lat && lon) {
      if (lat !== coordenadas.lat && lon !== coordenadas.lng) {
        setCoordenadas({ lat: Number(lat), lng: Number(lon) });
      }
    }

    if (produto) {
      setprodutoSelecionado(produto);
    }

    if (referencePoint) {
      setEndereco(referencePoint);
    }
  }

  useEffect(setDefaultValues, [defaultValues]);

  const listProducts = useMemo(() => {
    const list = [];
    products.forEach(id => {
      const card = PRODUCTS[id];
      if (card) {
        list.push({
          ...card,
          image: getIconByProduto(card.code),
        });
      }
    });

    return list;
  }, [products]);

  function validarEndereco() {
    const latElement = document.querySelector('#lat');
    const lngElement = document.querySelector('#lon');
    const lat = latElement ? latElement.value : '';
    const lng = lngElement ? lngElement.value : '';
    const referencePointValue = formSearchRef.current
      ? formSearchRef.current.querySelector('input[name="referencePoint"]')
          .value
      : null;

    let mensagemErroEndereco = '';
    if (!(lng && lat)) {
      mensagemErroEndereco = 'Endereço inválido ou incompleto';
    }

    if (!referencePointValue) {
      mensagemErroEndereco = 'Campo obrigatório';
    }

    setMessageAddressError(mensagemErroEndereco);
    return mensagemErroEndereco;
  }

  function validar() {
    let mensagemErroProduto = '';

    const productValue = formSearchRef.current.querySelector(
      'input[name="produto"]',
    ).value;

    if (!productValue) {
      mensagemErroProduto = 'Selecione um produto';
    }

    setMessageProductError(mensagemErroProduto);
    return !validarEndereco() && !mensagemErroProduto;
  }

  function formIsValid() {
    if (formSearchRef.current) {
      const productValue = formSearchRef.current.querySelector(
        'input[name="produto"]',
      ).value;

      return !messageAddressError && productValue && endereco;
    }
    return false;
  }

  function handleSubmit(e) {
    e.preventDefault();

    if (validar() || !validate) {
      const formSearch = {};
      const elements = formSearchRef.current.querySelectorAll('input, select');

      elements.forEach(el => {
        const value = el.type === 'checkbox' ? el.checked : el.value;
        formSearch[el.name] = value;
      });

      if (findEstablishment) {
        findEstablishment(formSearch);
      }

      if (setSearch) {
        setSearch(formSearch);
      }

      if (showResumoResultados) {
        setShowResultados(true);
        setFullBox(true);
      }
    }
  }

  function onSelectCoordenadas(result) {
    setEndereco(result.place.description);

    if (result.status) {
      setCoordenadas(result.location);
    } else {
      setCoordenadas({ lat: '', lng: '' });
    }
  }

  function onEditProduct() {
    setShowForm(!showForm);

    const productValue = formSearchRef.current.querySelector(
      'input[name="produto"]',
    ).value;

    setMessageProductError(productValue ? null : 'Selecione um produto');

    if (endereco && coordenadas.lat && coordenadas.lng) {
      setMessageAddressError('');
    }
  }

  useEffect(() => {
    if (endereco) {
      setMessageAddressError(null);
    }
  }, [endereco]);

  return (
    <FormBusca
      id="formSearch"
      name="formSearch"
      ref={formSearchRef}
      onSubmit={handleSubmit}
      open={openBox}
      noValidate
    >
      <ContainerForm id="search--container-map" expanded={openBox}>
        <If test={showForm}>
          <ContainerInput>
            <TextFieldGoogleAutocomplete
              google={window.google}
              ref={searchInputRef}
              className={messageAddressError ? 'has-error invalid' : ''}
              name="referencePoint"
              autoComplete="off"
              label="Digite o nome ou endereço de um lugar"
              messageError={messageAddressError}
              value={endereco}
              onChange={e => setEndereco(e.target.value)}
              onSelect={onSelectCoordenadas}
              onFocus={() => setMessageAddressError('')}
              onBlur={validarEndereco}
              required
            />
          </ContainerInput>
        </If>

        <SelectProducts
          value={produtoSelecionado}
          onSelect={setprodutoSelecionado}
          products={listProducts}
          onEdit={onEditProduct}
          messageError={messageProductError}
          renderOption={renderOption}
          height={height}
          companyName={companyName}
        />

        <input type="hidden" name="lon" id="lon" value={coordenadas.lng} />
        <input type="hidden" name="lat" id="lat" value={coordenadas.lat} />
        <input type="hidden" name="raio" id="raio" value={raio} />

        <If test={showForm}>
          <>
            {children}

            <SwitchContainer>
              <Switch
                name="delivery"
                description="Listar restaurantes que fazem entrega"
              />
            </SwitchContainer>

            <Button type="submit" disabled={!formIsValid()}>
              Buscar
            </Button>
          </>
        </If>
      </ContainerForm>
    </FormBusca>
  );
}

Search.propTypes = {
  products: PropTypes.arrayOf(PropTypes.any),
  renderOption: PropTypes.func,
  children: PropTypes.node,
  onSelectPlace: PropTypes.func,
  validate: PropTypes.bool,
  defaultValues: PropTypes.shape({
    lon: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    lat: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    estabelechiment: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    referencePoint: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    produto: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  height: PropTypes.string,
};

Search.defaultProps = {
  products: [],
  renderOption: null,
  children: null,
  onSelectPlace: null,
  validate: true,
  defaultValues: {},
  height: 'auto',
};

export default Search;
